import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const OptionStyled = styled.label`
  flex-basis: 33%;
  flex-grow: 1;
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  min-height: ${p => p.theme.basketItem.option.lineHeight};
  ${media.small`
    width: 100%;
  `};
`;

export const OptionInput = styled.input`
  display: ${p => p.theme.basketItem.option.display};
`;

export const OptionText = styled.span`
  cursor: pointer;
  text-align: center;
  width: 100%;
  border-radius: ${p => p.theme.basketItem.option.borderRadius};
  margin: ${p => p.theme.basketItem.option.margin};
  padding: ${p => p.theme.basketItem.option.padding};
  font-size: ${p => p.theme.basketItem.option.fontSize};
  color: ${p => p.isChecked ? p.theme.primaryColor : p.theme.basketItem.optionsGroup.color};
  background-image: ${p => p.isChecked ? p.theme.basketItem.selected.backgroundImage : 'none'};
  background-color: ${p => p.isChecked ? p.theme.basketItem.selected.backgroundColor : p.theme.basketItem.option.backgroundColor};
  box-shadow: ${p => p.isChecked ? p.theme.basketItem.selected.boxShadow : 'none'};
  &:hover {
    background-color: ${p => p.theme.basketItem.selected.color};
    background-image: ${p => p.isChecked ? '' : p.theme.basketItem.option.backgroundImage};
    box-shadow: ${p => p.isChecked ? '' : p.theme.basketItem.option.boxShadow};
  }
`;

export const ExtraPrice = styled.span`
  display: block;
  font-weight: bold;
`;



// WEBPACK FOOTER //
// ./components/Meal/Option.style.js